import { Board, Society, BoardParticipant, Partner } from 'types';
import { getPartnerById, getPartnerNDPercent } from 'utils/filters';

type GetParticipantPercentProps = {
  actualSociety: Society;
  board: Board;
  participant: BoardParticipant;
  partners: Partner[];
};

export const getParticipantPercent = ({
  actualSociety,
  board,
  participant,
  partners,
}: GetParticipantPercentProps): number => {
  const partner = getPartnerById(partners, participant.member);

  const percent = board?.societySharesCount
    ? ((participant?.sharesCount || 0) * 100) / board.societySharesCount
    : getPartnerNDPercent(partner, actualSociety);

  return percent || 0;
};
